const settings = {
	compressedView: {
		defaultValue: false,
		title: "Compressed view",
		helperText: "Reduce spacing and row heights.",
		type: "boolean"
	},
	hideDeprecated: {
		defaultValue: false,
		title: "Hide decommissioned items",
		helperText: "Hide from main lists and searches.",
		type: "boolean"
	},
	logActivity: {
		defaultValue: true,
		title: "Log activity",
		helperText: "Log activity to get suggestions.",
		type: "boolean"
	},
	showDoy: {
		defaultValue: false,
		title: "Show DOY",
		helperText: "Display the current day of the year.",
		type: "boolean"
	}
};

export default settings;
